// Footer.js
import React from 'react';
import { FaChevronRight } from 'react-icons/fa';
import FacebookIcon from '../components/img/facebook.png';
import LinkedinIcon from '../components/img/linkedin.png';
import InstagramIcon from '../components/img/insta.png';
import YoutubeIcon from '../components/img/youtube.png';

const Footer = () => {
    return (
        <div>
            {/* Contact Section */}
            <section className='contact-section'>
                <div className="contact-info-container">
                    <div className="contact-info-item">
                        <p>Ambulance</p>
                        <a href="tel:+919496555200">+91 (0) 9496555200</a>
                    </div>
                    <div className="contact-info-item">
                        <p>Appointments</p>
                        <a href="tel:0481 2792500">0481 2792500</a>
                    </div>
                    <div className="contact-info-item">
                        <p>Information 24/7</p>
                        <a href="tel:0481 2792500">0481 2792500</a>
                    </div>
                    <div className="contact-info-item">
                        <p>Health Check-up plans</p>
                        <a href='tel:+91 9496555900'>+91 (0) 9496555900</a>
                    </div>
                </div>
            </section>


            {/* Specialities Section */}
            <section className="specialities-section">
                <p className="specialities-heading">Specialities</p>
                <div className="specialities-container">
                    <div className="speciality-links">
                        <a href="/gynaecology"><p className="speciality-names"><FaChevronRight className='dept-icon' /> Obstetrics, Gynaecology and Fetal Medicine</p></a>
                        <a href="/emergency-medicine"><p className="speciality-names"><FaChevronRight className='dept-icon' /> Emergency Medicine & Trauma Care</p></a>
                        <a href="/paediatrics-and-paediatrics-surgery"><p className="speciality-names"><FaChevronRight className='dept-icon' /> Paediatrics & Paediatrics Surgery</p></a>
                        <a href="/neonatology"><p className="speciality-names"><FaChevronRight className='dept-icon' /> Neonatology</p></a>
                        <a href="/cardiology"><p className="speciality-names"><FaChevronRight className='dept-icon' /> Cardiology</p></a>
                        <a href="/orthopaedics"><p className="speciality-names"><FaChevronRight className='dept-icon' /> Orthopaedics, Joint Replacement & Arthroscopy</p></a>
                        <a href="/ent-audiology"><p className="speciality-names"><FaChevronRight className='dept-icon' /> Department of ENT & Audiology</p></a>
                        <a href="/dental"><p className="speciality-names"><FaChevronRight className='dept-icon' />  Dental, Oral & Maxillofacial Surgery</p></a>
                        <a href="/plastic-surgery"><p className="speciality-names"><FaChevronRight className='dept-icon' /> Plastic and Microvascular Surgery</p></a>
                        <a href="/dermatology"><p className="speciality-names"><FaChevronRight className='dept-icon' /> Dermatology</p></a>
                        <a href="/ophthalmology"><p className="speciality-names"><FaChevronRight className='dept-icon' /> Ophthalmology</p></a>
                        <a href="/general-medicine"><p className="speciality-names"><FaChevronRight className='dept-icon' /> General Medicine</p></a>
                        <a href="/general-surgery"><p className="speciality-names"><FaChevronRight className='dept-icon' /> General, Minimal Access and <br />Bariatric Surgery (General Surgery)</p></a>
                        <a href="/neurology"><p className="speciality-names"><FaChevronRight className='dept-icon' /> Neuro Science</p></a>
                    </div>
                </div>
            </section>

            {/* Footer Contact Section */}
            <section className="footer-contact-section">
                <div className="footer-contact-container">
                    <div className="footer-column">
                        <h6 className="footer-heading">Contact</h6>
                        <h6 className="footer-sub-heading">Address</h6>
                        <p className="footer-links"> MC Road, Thellakom (P.O), <br />Kottayam, Kerala - 686630</p>
                        <h6 className="footer-sub-heading">Contact Number</h6>
                        <a href="tel:0481 2792500"><p className="footer-links"> 0481 2792500</p></a>
                        <h6 className="footer-sub-heading">Email Id</h6>
                        <a href="mailto:cmh@caritashospital.org"><p className="footer-links"> cmh@caritashospital.org</p></a>
                        <h6 className="footer-sub-heading">Patient Feedback</h6>
                        <a href="mailto:patientfeedback@caritashospital.org"><p className="footer-links"> patientfeedback@caritashospital.org</p></a>
                        <a href="/appointment">
                            <button className='footer-appointments'>Appointments</button>
                        </a>
                    </div>
                    <div className="footer-column">
                        <h6 className="footer-heading">About</h6>
                        <a href="/about-caritas-matha"><p className="footer-links"> About Caritas Matha Hospital</p></a>
                        <a href="/director-message"><p className="footer-links"> Director's Message</p></a>
                        <a href="/governing-body"><p className="footer-links"> Governing Body</p></a>
                        <a href="https://www.caritashospital.org/career/"><p className="footer-links"> Careers at Caritas</p></a>
                        <a href="/biomedicals"><p className="footer-links"> Biomedical Waste Management</p></a>
                        <a href="/quality-indicators"><p className="footer-links"> Quality Indicators</p></a>
                        <a href="/directions-to-reach"><p className="footer-links"> Directions to Reach</p></a>
                        <a href="/doctors"><p className="footer-links"> Find a Doctor</p></a>
                        <a href="/contact-us"><p className="footer-links"> Contact Us</p></a>
                    </div>
                    <div className="footer-column">
                        <h6 className="footer-heading">Services</h6>
                        <a href="/radiology-laboratory"><p className="footer-links"> Radiology & Laboratory</p></a>
                        <a href="/blood-bank"><p className="footer-links"> Blood Bank</p></a>
                        <a href="/clinical-nutrition"><p className="footer-links"> Clinical Nutrition</p></a>
                        <a href="/insurance-partners"><p className="footer-links"> Insurance Partners</p></a>
                        <a href="/video-consultation"><p className="footer-links"> Video Consultation</p></a>
                        <a href="/caritas-mortuary-services"><p className="footer-links"> Caritas Mortuary Services</p></a>
                        <a href="/pastoral-care"><p className="footer-links"> Pastoral Care</p></a>
                        <a href="/caritas-home-care"><p className="footer-links"> Caritas Home Care</p></a>
                        <a href="https://www.caritashospital.org/health-checkup-packages"><p className="footer-links"> Health Checkup Packages</p></a>
                    </div>
                    <div className="footer-column">
                        <h6 className="footer-heading">Our Hospitals</h6>
                        <a href="https://caritashospital.org/"><p className="footer-links"> Caritas Hospital</p></a>
                        <a href="https://www.caritasfamilyhospital.com/"><p className="footer-links"> Caritas Family Hospital</p></a>
                        <a href="https://caritashospital.org/caritaskkm/"><p className="footer-links"> Caritas KMM Hospital</p></a>
                        <a href="https://caritashospital.org/caritas-hdp-hospital/"><p className="footer-links"> Caritas HDP Hospital</p></a>
                        <h6 className="footer-heading">Resources</h6>
                        <a href="/news-and-events"><p className="footer-links"> News & Events</p></a>
                        <a href="/articles"><p className="footer-links"> Articles to Read</p></a>
                        <a href="/testimonials"><p className="footer-links"> Patient Testimonials</p></a>
                        <a href="/video-gallery"><p className="footer-links"> Video Gallery</p></a>
                    </div>
                </div>
            </section>

            {/* Footer Section */}
            <footer className="footer-section">
                <div className="footer-container">
                    <div className="footer-icons">
                        <a href="https://www.facebook.com/CaritasMathaHospital/" target="_blank" rel="noopener noreferrer"><img src={FacebookIcon} className='social-media-icons'/></a>
                        <a href="https://www.linkedin.com/company/caritashospital/" target="_blank" rel="noopener noreferrer"><img src={LinkedinIcon} className='social-media-icons'/></a>
                        <a href="https://www.instagram.com/caritasmathahospitalktm/" target="_blank" rel="noopener noreferrer"><img src={InstagramIcon} className='social-media-icons'/></a>
                        <a href="https://www.youtube.com/channel/UCKZOzDHqQNwu6ZIreumi9bQ" target="_blank" rel="noopener noreferrer"><img src={YoutubeIcon} className='social-media-icons'/></a>
                    </div>
                    <div className="footer-text">
                        <a href="/privacy-policy">Privacy Policy</a> | <a href="/terms-conditions">Terms & Conditions</a> | <a href='/'>All Rights Reserved © 2025. Caritas Matha Hospital</a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
